import React from 'react';
import PropTypes from 'prop-types';
import { MemoryPhotoV1 } from '../MemoryPhotoV1';
import { BLOCKS, INTRO_HINT } from '../../shared/memory-map-data';
import { CHAPTER_INTRO_IMAGES } from '../../shared/memory-map-assets';
import styles from './PauseSlideContentV30.css';

const CHAPTERS_COUNT = BLOCKS.length;

function PauseSlideContentV30({ blockIndex }) {
    const block = BLOCKS[blockIndex];

    return (
        <section className={styles.form}>
            <div className={styles.card}>
                <p className={styles.eyebrow}>{`${block.chapter} of ${CHAPTERS_COUNT}`}</p>
                <h1 className={styles.heading}>{block.name}</h1>
                <p className={styles.description}>{INTRO_HINT[blockIndex]}</p>
            </div>
            <MemoryPhotoV1 imageId={CHAPTER_INTRO_IMAGES[blockIndex]} radius='small' />
        </section>
    );
}

PauseSlideContentV30.propTypes = {
    blockIndex: PropTypes.number.isRequired
};

export {
    PauseSlideContentV30
};
